export enum FilePanelTypes {
  commit,
  property,
  analysis,
  commitSearch,
  vray,
  renderOutput,
}
